// extracted by mini-css-extract-plugin
module.exports = {"body":"AlertBanner_body__1v98n","panel":"AlertBanner_panel__22gQB","slide-bottom":"AlertBanner_slide-bottom__1h5pa"};